import { Tournament } from "src/components/WeekAtAGlance/IndividualTournament";
import Layout from "../components/layout/Layout";
import DashboardTabs from "../components/ui/DashboardTabs";
import TournamentPlayerSubmission from "src/components/Tournaments/TournamentPlayerSubmission";

function AddTournamentPlayer({
  eventId,
  clubId,
  TournamentDate,
  devPort,
  waiverNotifications,
  managerMode,
  eventDetails,
}: {
  eventId: string;
  clubId: string;
  TournamentDate: string;
  devPort: string;
  waiverNotifications: boolean;
  managerMode: number;
  eventDetails: Tournament;
}) {
  //const [currentPage, setCurrentPage] = useState("signups");
  const currentPage = "/addtournamentplayer";
  return (
    <Layout
      managerMode={managerMode}
      waiverNotifications={waiverNotifications}
      devPort={devPort}
    >
      <DashboardTabs
        currentPage={currentPage}
        managerMode={managerMode}
        gameMode="tournament"
        toReload={false}
        saveToDb={false}
      />
      <TournamentPlayerSubmission
        devPort={devPort}
        clubId={clubId}
        eventDetails={eventDetails}
        managerMode={managerMode}
      />
    </Layout>
  );
}

export default AddTournamentPlayer;
